import { DataBaseModelInterface } from '@solcre-org/core';
import { PortCallPdaLineModel } from './port-call-pda-line.model';
import { CargoOperationBreakdownEntry } from './port-call-pda-cargo-breakdown.model';
import { PortCallPdaStatuses } from '../enums/port-call-pda-status.enum';

export class PortCallPdaModel implements DataBaseModelInterface {
  constructor(
    public id?: any,
    public portCallId?: any,
    public sourceTariffId?: any,
    public port?: {
      code?: string;
      name?: string;
      terminal?: string;
      berthingType?: string;
    },
    public vessel?: {
      id?: any;
      name?: string;
      loa?: string;
      beam?: string;
      grt?: string;
      nrt?: string;
      dwt?: string;
    },
    public stayHours?: string,
    public stayDays?: string,
    public cargoOperationBreakdown: CargoOperationBreakdownEntry[] = [],
    public cargoOperationSummary?: {
      loadingQuantity?: number;
      dischargeQuantity?: number;
    },
    public subtotalUsd?: string,
    public taxTotalUsd?: string,
    public totalUsd?: string,
    public previousTotalUsd?: string | null,
    public hasManualOverrides: boolean = false,
    public hasStaleInputs: boolean = false,
    public staleReasons: string[] = [],
    public staleDetectedAt?: string | null,
    public status?: PortCallPdaStatuses | string,
    public calculatedAt?: string,
    public approvedAt?: string | null,
    public lines: PortCallPdaLineModel[] = []
  ) {}

  public fromJSON(json: any): PortCallPdaModel {
    if (json) {
      this.id = json.id;
      this.portCallId = json.portCallId;
      this.sourceTariffId = json.sourceTariffId;
      this.port = json.port;
      this.vessel = json.vessel;
      this.stayHours = json.stayHours;
      this.stayDays = json.stayDays;
      this.cargoOperationBreakdown = Array.isArray(json.cargoOperationBreakdown) ? json.cargoOperationBreakdown : [];
      this.cargoOperationSummary = json.cargoOperationSummary;
      this.subtotalUsd = json.subtotalUsd;
      this.taxTotalUsd = json.taxTotalUsd;
      this.totalUsd = json.totalUsd;
      this.previousTotalUsd = json.previousTotalUsd ?? null;
      this.hasManualOverrides = json.hasManualOverrides ?? false;
      this.hasStaleInputs = json.hasStaleInputs ?? false;
      this.staleReasons = json.staleReasons ?? [];
      this.staleDetectedAt = json.staleDetectedAt ?? null;
      this.status = json.status;
      this.calculatedAt = json.calculatedAt;
      this.approvedAt = json.approvedAt ?? null;
      this.lines = Array.isArray(json.lines)
        ? new PortCallPdaLineModel().fromJSONList(json.lines)
        : [];
    }
    return this;
  }

  public fromJSONList(json: any): PortCallPdaModel[] {
    if (json) {
      return json.map((element: any) => new PortCallPdaModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      portCallId: this.portCallId,
      sourceTariffId: this.sourceTariffId,
      port: this.port,
      vessel: this.vessel,
      stayHours: this.stayHours,
      stayDays: this.stayDays,
      cargoOperationBreakdown: this.cargoOperationBreakdown,
      cargoOperationSummary: this.cargoOperationSummary,
      subtotalUsd: this.subtotalUsd,
      taxTotalUsd: this.taxTotalUsd,
      totalUsd: this.totalUsd,
      previousTotalUsd: this.previousTotalUsd,
      hasManualOverrides: this.hasManualOverrides,
      hasStaleInputs: this.hasStaleInputs,
      staleReasons: this.staleReasons,
      status: this.status,
      calculatedAt: this.calculatedAt,
      approvedAt: this.approvedAt,
      lines: this.lines.map((l) => l.toJSON()),
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return `PDA-${this.portCallId ?? this.id ?? ''}`;
  }
}
